import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import { SlotController } from '../../controllers/slot-controller';
import defaultVars from './css-variables/sic-pager-vars.css.lit';
/**
 * The SicPager component
 * @element sic-pager
 *
 * Lightdom styles in sic-pager.lightdom.css included in /shared.css
 */
@customElement('sic-pager')
export class SicPager extends OutlineElement {
  static styles: CSSResultGroup = [defaultVars];
  slots: SlotController = new SlotController(this, false);

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
